export default __webpack_public_path__ + "static/media/mojo_system.bc6b8a28.png";